import styled, {css} from "styled-components";
import {Smoke, Teal} from "../../../../theme/variable";
import {media} from "../../../../theme/responsive";
import applyBanner_icon from "../../../../images/applyBanner_icon.svg";
import ULP_Sprite from "../../../../images/ULP_Sprite.svg";

export const BannerCard = styled.div`
    width: 100%;
    border-bottom: 1px solid ${Smoke};
    p {
        font-size: 1rem;
        padding: 20px 10px 15px;
        font-weight: 600;
        text-align: center;
        ${media.laptop`padding:25px 0 15px;`}
    }
`;
export const BannerCardWrapper = styled.div`
    width: 100%;
    display: table;
`;
export const BannerCardBox = styled.div`
    display: block;
    width: 100%;
    padding: 0;
    text-align: center;

    ${media.laptop` width:33%;display:table-cell;padding:0px 30px 15px 30px`}
`;
export const BannerContent = styled.div`
    display: inline-block;
    width: 68%;
    vertical-align: middle;
    text-align: left;
    strong {
        font-weight: 600;
        font-size: 0.875rem;
        display: block;
        margin-bottom: 3px;
        ${media.laptop` font-size:1rem;margin-bottom:5px;`}
    }
    p {
        font-size: 0.75rem;
        font-weight: 400;
        padding: 0;
        text-align: left;
        line-height: 17px;
        ${media.laptop`font-size:0.875rem;text-align:center;`}
    }
    ${media.laptop` display:block;width:100%;text-align:center`}
`;
export const iconStyles = css`
    background: url(${applyBanner_icon}) no-repeat;
    width: 90px;
    height: 80px;
    display: inline-block;
    background-size: 265px 78px;
    vertical-align: middle;
    margin-right: 10px;
    ${media.laptop` display:inline-block;background-size:cover;height:90px;margin-right:0;`}
`;
export const TransparentProcessIcon = styled.i`
    ${iconStyles};
    background-position: 0 0;
`;
export const WideChoiceUnivIcon = styled.i`
    ${iconStyles};
    background-position: -93px -6px;
    background-size: 289px 78px;
`;
export const FastResponseIcon = styled.i`
    ${iconStyles};
    background-position: -188px -40px;
    position: relative;
    top: 22px;
    background-size: 310px 78px;
    ${media.laptop`top:30px;`}
`;
export const BannerLink = styled.div`
    padding: 10px 0;
    border-top: 1px solid ${Smoke};
    text-align: center;
    color: ${Teal};
    a {
        font-weight: 400;
        font-size: 0.875rem;
        max-width: 100%;
        line-height: 22px;
        ${media.laptop` font-weight:600;`}
    }
    a:after {
        content: "";
        background: url(${ULP_Sprite}) no-repeat;
        background-position: -61px -23px;
        display: inline-block;
        position: relative;
        top: 2px;
        left: 3px;
        margin-right: 3px;
        width: 10px;
        height: 18px;
        border: none;
        transform: rotate(0deg);
    }
    ${media.laptop`padding:14px;`}
`;
